import "./Dashboard.css";
import React, { useContext, useEffect, useState } from "react";
import Sidebar from "./Sidebar/Sidebar";
import { AppBar, Box, CssBaseline, Toolbar, Typography } from "@mui/material";
import TopHeaderBar from "./TopHeaderBar/TopHeaderBar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { dashboardPath } from "./dashboardPath";
import { AuthContext } from "../../auth/authContext";
import { UserRole } from "../../const/enum";

const drawerWidth = 150;

const Dashboard = () => {
  const location = useLocation();
  const [currentMenu, setCurrentMenu] = useState(""); // 用于存储当前菜单名字的状态
  const dashboardPaths = dashboardPath();
  const authContext = useContext(AuthContext);
  const [username, setUsername] = useState<string>(
    authContext?.user?.name || "",
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (authContext) {
      const { user } = authContext;
      if (user) {
        let role = user.role;
        if (role) {
          role = UserRole[role];
        }
        setUsername(`${user.name}(${role})` || "");
      }
    }
  }, [authContext]);

  const handleLogout = () => {
    authContext?.logout();
    navigate("/login");
  };

  useEffect(() => {
    // 根据路由变化，设置当前菜单名字
    const locationName = location.pathname.split("/");
    const key = locationName[locationName.length - 1];
    const menu = () => {
      for (const path of dashboardPaths) {
        for (const subpath of path.subPaths) {
          if (subpath.path === key) {
            return `${path.name} -> ${subpath.name}`;
          }
        }
      }
      return "";
    };
    setCurrentMenu(menu());
  }, [location, dashboardPaths]);
  return (
    <Box className="dashboard">
      <CssBaseline />
      <TopHeaderBar
        drawerWidth={drawerWidth}
        username={username}
        handleLogout={handleLogout}
      />
      <Sidebar drawerWidth={drawerWidth} />
      <Box component="main" className="dashboard-main">
        <AppBar position="relative" className="app-bar">
          <Toolbar>
            <Typography variant="h6" className="menu-title">
              {currentMenu}
            </Typography>
          </Toolbar>
        </AppBar>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Dashboard;
